import { Component, OnInit, ViewChild} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../../services/general.service';
import { GroupService } from '../../../services/group.service';
import {ModalConfirmComponent} from '../../../modal-confirm/modal-confirm.component';

@Component({
  selector: 'app-workflows',
  templateUrl: './workflows.component.html',
  styleUrls: ['./workflows.component.scss']
})
export class WorkflowsComponent implements OnInit {
  @ViewChild('tabGroup', { static: false }) tabGroup;
  userId: any;
  userToken: any;
  listapprovers = [];
  listWorkflows = [];
  workflowType1 = [];// ---
  load = true;
  loadBtn = false;
  selectedIndex: any = 0;

  constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private router: Router, private groupService: GroupService) {
    const b = JSON.parse(decodeURIComponent(localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352')));
    this.userId = b['id'];
    this.userToken = b['session_token'];
    gralService.changeTextHead('WORKFLOWS');
    this.getApprovers();
    this.getWorkflows();
  }

  ngOnInit() {
  }

  getWorkflows(){
    this.groupService.getWorkflows(this.userId, this.userToken).then((data) => {
      this.listWorkflows = data['msg'];
      this.load = false;
    }, (err) => {
      console.log(err);
      this.load = false;
      this.listWorkflows = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }

      if(err['status'] != 400){
        this.toastr.error(err['error'].msg, 'Error al cargar flujos de aprobacion');
      }
    });
  }



  getApprovers(){
    this.groupService.getApprovers(this.userId, this.userToken).then((data) => {
      this.listapprovers = data['msg'];
    }, (err) => {
      console.log(err);
      this.listapprovers = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }

      if(err['status'] != 400){
        this.toastr.error(err['error'].msg, 'Error al cargar lista de usuarios');
      }
    });
  }

  selectedTab(event){
    setTimeout(() => {
      this.selectedIndex = this.tabGroup.selectedIndex;
    })
  }

  saveWorkFlowApprovers(flow){
    console.log(flow);
    // validaciones

    this.loadBtn = true;
    this.groupService.workflowApprover(flow, this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      console.log(data);
      this.toastr.success('Se modifico correctamente el flujo de aprobación', 'Flujo de aprobación');
    }, (err) => {
      this.loadBtn = false;
      console.log(err);
      this.toastr.error(err['error'].msg, 'Error al guardar');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });

  }

}
